/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/prop-types */
import { yupResolver } from '@hookform/resolvers/yup';
import { LoadingButton } from '@mui/lab';
import { Button, Stack, useTheme } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useSnackbar } from 'notistack';
import { useMemo } from 'react';
import { useForm } from 'react-hook-form';
import * as Yup from 'yup';
import { FormProvider, RHFEditor } from '../../components/hook-form';
import useAuth from '../../hooks/useAuth';
import useLocales from '../../hooks/useLocales';
import { setCommentSearch } from '../../redux/slices/blog/blog.comment';
import { useDispatch, useSelector } from '../../redux/store';
import { createCommentAPI, updateCommentAPI } from '../../service/blog/blog.comment.service';

// ----------------------------------------------------------------------
const RootStyles = styled('div')(({ theme }) => ({
  padding: theme.spacing(1),
  borderRadius: Number(theme.shape.borderRadius),
  backgroundColor: theme.palette.background.neutral,
}));
// ----------------------------------------------------------------------

export default function CommentNewForm({
  itemId,
  type,
  isEdit,
  id,
  content,
  setEditable
}) {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const { translate } = useLocales();
  const theme = useTheme();

  //name field
  const description = `description${itemId || id}${type}`;

  const { isAuthenticated } = useAuth();
  const { search } = useSelector((state) => state.blogComment);

  const NewItemSchema = Yup.object().shape({
    [description]: Yup.string().required(translate('validation.required')),
  });

  const defaultValues = useMemo(
    () => ({
      [description]: content || '',
    }),
    [id]
  );

  const methods = useForm({
    resolver: yupResolver(NewItemSchema),
    defaultValues,
  });

  const {
    handleSubmit,
    reset,
    formState: { isSubmitting },
  } = methods;

  const onSubmit = async (data) => {
    if (!isAuthenticated) {
      enqueueSnackbar(translate('label.signinToGPLX'), { variant: 'error' });
      return;
    }

    const request = {
      id,
      itemId,
      type,
      description: data[description],
    };

    let resp = null;
    if (isEdit) resp = await updateCommentAPI(request);
    else resp = await createCommentAPI(request);

    if (resp.code === '200') {
      reset();
      dispatch(setCommentSearch({ ...search, page: 0 }));
      if (isEdit) {
        setEditable(false);
        enqueueSnackbar(translate('message.updateSuccess'));
      } else enqueueSnackbar(translate('message.createSuccess'));
    } else enqueueSnackbar(`${resp.code} - ${resp.message}`, { variant: 'error' });
  };

  return (
    <RootStyles>
      <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
        <RHFEditor
          name={description}
          simple
          sx={{
            '& .ql-editor': {
              height: 90,
              minHeight: 80,
            },
            '& .ql-toolbar.ql-snow': {
              padding: '0px 8px',
            },
            '& .ql-formats': {
              marginRight: '0px!important',
            },
            '& .ql-container.ql-snow': {
              ...theme.typography.body1,
            },
          }}
          placeholder={translate('label.writeComment')}
        />
        <Stack direction={'row'} spacing={2} justifyContent={'flex-end'}>
          {isEdit && (
            <Button color="inherit" type="button" variant="text" onClick={() => setEditable(false)}>
              {translate('button.close')}
            </Button>
          )}
          <LoadingButton type="submit" variant="contained" loading={isSubmitting}>
            {translate('button.comment')}
          </LoadingButton>
        </Stack>
      </FormProvider>
    </RootStyles>
  );
}
